import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { X, ShieldAlert } from "lucide-react";
import { useLang } from "../i18n";

export function ContentWarning({ open, onEnter }) {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="content-warning"
          className="fixed inset-0 z-[2000] flex items-center justify-center bg-graphite/40 p-5 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8 }}
            transition={{ duration: 0.5 }}
            className="w-full max-w-md rounded-panel bg-white p-8 shadow-softlg"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-softpink text-dusty">
              <ShieldAlert size={24} strokeWidth={1.5} />
            </div>
            <h2 className="mt-5 text-2xl font-semibold tracking-tight text-graphite">
              {t("cw_title")}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-textsec">{t("cw_body")}</p>
            <p className="mt-4 rounded-xl bg-softpink px-4 py-3 text-xs leading-relaxed text-dusty-dark">
              {t("cw_tip")}
            </p>
            <div className="mt-6 flex flex-col gap-3">
              <button
                data-testid="cw-enter-btn"
                onClick={onEnter}
                className="w-full rounded-btn bg-dusty px-5 py-3 text-sm font-medium text-white shadow-soft transition-colors hover:bg-dusty-dark"
              >
                {t("cw_enter")}
              </button>
              <button
                data-testid="cw-leave-btn"
                onClick={() => navigate("/")}
                className="inline-flex items-center justify-center gap-2 text-sm font-medium text-textsec transition-colors hover:text-graphite"
              >
                <X size={15} strokeWidth={1.75} />
                {t("cw_leave")}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
